import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isNumber from 'lodash/isNumber';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';

export {
    cloneDeep,
    isArray,
    isObject,
    isNumber,
    isString,
    isEmpty,
    isFunction,
};
